import { Component } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, NavigationStart } from '@angular/router';
import { tap, distinctUntilChanged, filter, map } from 'rxjs/operators';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'app-wa';
  constructor(protected router: Router,
    protected $gaService: GoogleAnalyticsService
  ) {
    this.router.events.pipe(
      filter(a => a instanceof NavigationStart),
      distinctUntilChanged((f: NavigationStart, s: NavigationStart) => f.url === s.url),
      map(a => a),
      tap((a: NavigationStart) => {
        if (environment.production) {
          this.$gaService.pageView(a.url);
        }
      })).subscribe();
  }
}
